var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 *
 * @author Matthew Rawson
 * ButtonRouterLink has been extended out to auto include load promise handling displaying a loader when processing and
 * then reverting to the displaying the children when not processing. This will override the disabled state when
 * processing.
 *
 */
import React, { Component } from "react";
import id from "@irati/utils/id";
import { isPromise } from "@irati/utils/promise";
import Loader from "@irati/ui/src/Loading/Loader";
import { ButtonRouterLinkUI, ChildWrapper } from "./styled";
var ButtonRouterLink = /** @class */ (function (_super) {
    __extends(ButtonRouterLink, _super);
    function ButtonRouterLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            processing: false
        };
        _this._isMounted = false;
        _this.setProcessing = function (processing) {
            if (_this._isMounted) {
                _this.setState({ processing: processing });
            }
        };
        return _this;
    }
    ButtonRouterLink.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    ButtonRouterLink.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    ButtonRouterLink.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _this = this;
        /** Receive events from the load promise chain  */
        if (isPromise(nextProps.load)) {
            if (nextProps.load !== this.props.load) {
                this.setProcessing(true);
                nextProps.load
                    .then(function () {
                    _this.setProcessing();
                })
                    .catch(function (err) {
                    _this.setProcessing();
                    throw err;
                });
            }
        }
        else {
            this.setProcessing();
        }
    };
    ButtonRouterLink.prototype.render = function () {
        var idNamespace = id("ButtonRouterLink", this.props);
        var _a = this.props, load = _a.load, children = _a.children, disabled = _a.disabled, routerLinkProps = __rest(_a, ["load", "children", "disabled"]);
        var processing = this.state.processing;
        return (React.createElement(ButtonRouterLinkUI, __assign({}, routerLinkProps, { disabled: disabled || processing }),
            processing && React.createElement(Loader, { id: id("Loader", idNamespace) }),
            React.createElement(ChildWrapper, { id: id("ChildWrapper", idNamespace), className: "button-router-link-child-wrapper", processing: processing }, children)));
    };
    ButtonRouterLink.defaultProps = {
        load: Promise.resolve()
    };
    return ButtonRouterLink;
}(Component));
export default ButtonRouterLink;
